import { render, staticRenderFns } from "./ModuleLearning.vue?vue&type=template&id=cbca5eb8"
import script from "./ModuleLearning.vue?vue&type=script&lang=js"
export * from "./ModuleLearning.vue?vue&type=script&lang=js"
import style0 from "./ModuleLearning.vue?vue&type=style&index=0&id=cbca5eb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports